"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.builder = void 0;
exports.builder = {
    withPath: (path) => {
        const rule = { type: 'isBase64', path };
        return {
            build: () => rule,
        };
    },
    build: () => ({ type: 'isBase64' }),
};
//# sourceMappingURL=IsBase64Builder.js.map